<script>


    import formMixin from "../../mixins/formMixin";
    import getPropertyValue from "../../mixins/getPropertyValue";


    export default {
        name: 'dynamicFormProperty',
        mixins: [formMixin],
        props: {
            entity: Object,
            extension: Object,
        },
        methods: {
            getPropertyValue,
        },
        computed: {
            value: {
                get() {
                    if (this.change === null) {
                        return getPropertyValue(this.$props.entity, this.$props.dataProperty);
                    } else {
                        return this.change;
                    }
                },
                set(value) {
                    this.change = value;
                },
            },
            changeId() {
                if (this.$props.entity.properties && this.$props.entity.properties[this.$props.dataProperty]) {

                    return this.$props.entity.properties[this.$props.dataProperty].changeId;
                }
                console.log('entity not found');
                return undefined;
            },
        },
        mounted() {

        },
    }
</script>

<style lang="less" scoped>

</style>
